import { API_BASE, API_URL, APPLICATION_JSON_HEADER } from "@/constants";
import { User } from "@/types/api/user";
import { getApiError } from "@/utils/api-error";

import { AddressData } from "./types";

const ADDRESS_ENDPOINT = `${API_URL}${API_BASE}/address`;

export async function postAddress(body: AddressData): Promise<User> {
  const response = await fetch(ADDRESS_ENDPOINT, {
    method: "POST",
    headers: {
      ...APPLICATION_JSON_HEADER,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw await getApiError(response);
  }

  return response.json();
}
